import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShuffleOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shuffle_on"}/>
}
